import { render, staticRenderFns } from "./StepFourForm.vue?vue&type=template&id=751ac5e6"
import script from "./StepFourForm.vue?vue&type=script&lang=ts"
export * from "./StepFourForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports